export const AUTOMATIC_PRICE_ENDPOINT = '/bin/daimler/public/startingPrice';
export const AUTOMATIC_PRICE_DEBUG_SESSION_KEY = 'stageAutomaticPrice.debug';
